import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import ProgressBar from '../../components/ProgressBar/progressbar';
import Styles from './patchcenterStyle.module.scss';

import { useNavigate } from 'react-router-dom';
import Preview from './Preview';

const PreviewApprove = () => {
  const navigate = useNavigate();

  const handleCancelBtn = () => {
    navigate('/patchCenter'); // Navigate to the Action page
  };
  const handleNextBtn = () => {
    navigate('/patchCenter/Preview&Approve'); // Navigate to the Action page
  };

  const preview = ['Actions', 'Patches Available', 'Preview & Approve', 'Selected Devices'];
  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title="Preview & Approve" dropdown={2} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-0`} style={{ marginLeft: '60px' }}>
            <ProgressBar stepNum={5} identity={'Device select'} />
          </div>
          <div className="flex flex-col space-y-6 mt-6">
            {preview.map((heading, index) => (
              <Preview key={index} heading={heading} />
            ))}
          </div>

          <div className="mt-6 flex justify-end space-x-2.5">
            <button className="w-32 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700" onClick={handleCancelBtn}>
              Cancel
            </button>
            <button className="w-32 px-6 py-2 bg-red-600 rounded-[30px] shadow-md hover:bg-red-700" onClick={handleNextBtn}>
              Next
            </button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PreviewApprove;
